import { ITutorialPassos, MensagensPadrao } from '../../../Components/AdicionarAjuda';

export const IDs = {
    formularioDeFiltro: "formulario-de-filtros-do-aluno",

    filtroDeCPF: "campo-cpf-filtros-do-aluno",
    filtroDePassaporte: "campo-passaporte-filtros-do-aluno",
    filtroDeNome: "campo-nome-filtros-do-aluno",
    filtroDeGenero: "campo-genero-filtros-do-aluno",
    filtroDeIdadeMaiorOuIgual: "campo-intervalo-GE-idade-filtros-do-aluno",
    filtroDeIdadeMenorQue: "campo-intervalo-LT-idade-filtros-do-aluno",
    filtroDeDocumento: "campo-documento-filtros-do-aluno",
    filtroDeTipoDeDocumento: "campo-tipo-documento-filtros-do-aluno",
    filtroDeValorDoDocumento: "campo-valor-documento-filtros-do-aluno",

    filtroDeInclusoNasViagens: "campo-incluso-nas-viagens-filtros-do-aluno",

    filtroDeAtivo: "campo-ativo-filtros-do-aluno",

    botaoListar: "botao-listar-aluno",
    botaoAdicionar: "botao-adicionar-aluno",
}

export const Classes = {
    botaoEditar: "botao-editar-aluno",
    botaoDesativar: "botao-desativar-aluno",
}

export const ConsultarAluno: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.filtros.apresentacao, target: () => document.getElementById(IDs.formularioDeFiltro)! },
        { ...MensagensPadrao.filtros.nome, target: () => document.getElementById(IDs.filtroDeNome)! },
        {
            title: "Gênero",
            description: <>Você também pode filtrar os alunos por gênero usando o menu de seleção.</>,
            target: () => document.getElementById(IDs.filtroDeGenero)!
        },
        {
            title: "Idade maior ou igual",
            description: <>Insira a idade base. Os estudantes retornados terão idades maiores ou iguais a esse valor.</>,
            target: () => document.getElementById(IDs.filtroDeIdadeMaiorOuIgual)!
        },
        {
            title: "Idade menor que",
            description: <>Insira a idade limite. Somente serão retornados estudantes cujas idades sejam menores ao valor informado.</>,
            target: () => document.getElementById(IDs.filtroDeIdadeMenorQue)!
        },
        { ...MensagensPadrao.filtros.cpf, target: () => document.getElementById(IDs.filtroDeCPF)! },
        {
            title: "Passaporte",
            description: <>Insira o valor do passaporte do aluno, se aplicável</>,
            target: () => document.getElementById(IDs.filtroDePassaporte)!
        },
        {
            title: "Documento",
            description: <>É possível filtrar por outros documentos que estejam vinculado ao aluno</>,
            target: () => document.getElementById(IDs.filtroDeDocumento)!
        },
        {
            title: "Tipo de documento",
            description: <>Selecione o tipo de documento usando o menu</>,
            target: () => document.getElementById(IDs.filtroDeTipoDeDocumento)!
        },
        {
            title: "Valor",
            description: <>Em seguida, informe o valor desse documento</>,
            target: () => document.getElementById(IDs.filtroDeValorDoDocumento)!
        },
        { ...MensagensPadrao.filtros.ativo, target: () => document.getElementById(IDs.filtroDeAtivo)! },
        {
            title: "Incluso nas viagens",
            description: <>Você pode filtrar alunos que estejam inclusos em viagens específicas. Várias viagens podem ser combinadas.</>,
            target: () => document.getElementById(IDs.filtroDeInclusoNasViagens)!
        },

        { ...MensagensPadrao.filtros.botaoListar, target: () => document.getElementById(IDs.botaoListar)! },
    ]
}

export const AdicionarAluno: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.adicionar.entrada, target: () => document.getElementById(IDs.botaoAdicionar)! },
    ]
}

export const EditarAluno: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.editar, target: () => document.querySelector("." + Classes.botaoEditar)! },
    ]
}

export const DesativarAluno: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.desativar, target: () => document.querySelector("." + Classes.botaoDesativar)! },
    ]
}
